export default "__VITE_ASSET__CD3i1tzt__"